"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageToAll = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EDiveInputHint = void 0;
var diveObjectsData_1 = require("@dive/entities/diveObjectsData");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageWebsockets_1 = require("@voyage/multi-sockets/voyageWebsockets");
var voyageMessageIds_1 = require("./voyageMessageIds");
var EDiveInputHint;
(function (EDiveInputHint) {
    EDiveInputHint[EDiveInputHint["Null"] = 0] = "Null";
    EDiveInputHint[EDiveInputHint["SelectCrew"] = 1] = "SelectCrew";
    EDiveInputHint[EDiveInputHint["Move"] = 2] = "Move";
    EDiveInputHint[EDiveInputHint["Cast"] = 3] = "Cast";
    EDiveInputHint[EDiveInputHint["Smash"] = 4] = "Smash";
    EDiveInputHint[EDiveInputHint["Open"] = 5] = "Open";
    EDiveInputHint[EDiveInputHint["PickUp"] = 6] = "PickUp";
    EDiveInputHint[EDiveInputHint["SetPreferredTarget"] = 10] = "SetPreferredTarget";
    EDiveInputHint[EDiveInputHint["CancelAbility"] = 20] = "CancelAbility";
    EDiveInputHint[EDiveInputHint["SelectAbility_basic_useItem"] = 21] = "SelectAbility_basic_useItem";
    EDiveInputHint[EDiveInputHint["SelectAbility_basic_dropItem"] = 22] = "SelectAbility_basic_dropItem";
    EDiveInputHint[EDiveInputHint["SelectAbility_basic_dropLoot"] = 23] = "SelectAbility_basic_dropLoot";
    EDiveInputHint[EDiveInputHint["SelectAbility_basic_dropWeapon"] = 24] = "SelectAbility_basic_dropWeapon";
    EDiveInputHint[EDiveInputHint["SelectAbility_firewall"] = 30] = "SelectAbility_firewall";
    EDiveInputHint[EDiveInputHint["SelectAbility_lightningCloud"] = 31] = "SelectAbility_lightningCloud";
})(EDiveInputHint = exports.EDiveInputHint || (exports.EDiveInputHint = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Dive_MouseInput;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.frame);
    messageWriter_sidecar_1.messageWriter.write16(m, d.tx);
    messageWriter_sidecar_1.messageWriter.write16(m, d.ty);
    messageWriter_sidecar_1.messageWriter.write16(m, d.targetId);
    messageWriter_sidecar_1.messageWriter.write16(m, d.fromCrewId);
    messageWriter_sidecar_1.messageWriter.write16(m, d.fromMultiId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.hint);
    messageWriter_sidecar_1.messageWriter.writeBool(m, d.centerOn);
    messageWriter_sidecar_1.messageWriter.write8(m, d.equipSlot);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        frame: messageWriter_sidecar_1.messageWriter.read32(m),
        tx: messageWriter_sidecar_1.messageWriter.read16(m),
        ty: messageWriter_sidecar_1.messageWriter.read16(m),
        targetId: messageWriter_sidecar_1.messageWriter.read16(m),
        fromCrewId: messageWriter_sidecar_1.messageWriter.read16(m),
        fromMultiId: messageWriter_sidecar_1.messageWriter.read16(m),
        hint: messageWriter_sidecar_1.messageWriter.read8(m),
        centerOn: messageWriter_sidecar_1.messageWriter.readBool(m),
        equipSlot: messageWriter_sidecar_1.messageWriter.read8(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        frame: 120,
        tx: 100,
        ty: 200,
        targetId: 123,
        fromCrewId: 12234,
        fromMultiId: 456,
        hint: EDiveInputHint.Move,
        centerOn: true,
        equipSlot: diveObjectsData_1.EDiveEquipSlot.Weapon,
    };
    messageWriter_sidecar_1.messageWriter.test('mouseInput', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, fromId) {
    var msg = read(m);
    // msg._fromId = fromId
    // TODO: check that targetId is the same as fromId??
    if (!msg.frame) {
        if (voyageWebsockets_1.getIsHost() && !isFromHost) {
            if (diveSimulationManager_sidecar_1.diveSimulationManager.isPlayerOnCorrectGameSync(fromId)) {
                var updatedMsg = Object.assign({}, msg, {
                    frame: diveSimulationManager_sidecar_1.diveSimulationManager.get().nextMessageSimulationFrame,
                });
                // console.log('mouseInput', 'updating msg', updatedMsg)
                sendMessageToAll(updatedMsg);
            }
            else {
                console.log('mouseInput', 'rejecting message, out of sync');
            }
        }
    }
    else {
        // Add to our frame stack
        diveSimulationManager_sidecar_1.diveSimulationManager.addMessageToBuffer(msg);
        // if (msg.hint === EDiveInputHint.Select) {
        //   voyagePicker.receiveSetSelection(msg)
        // }
    }
    // let cur = voyageMultiplayerCursors.findByMultiIdSafe(fromId)
    // if (cur) {
    //   voyageMultiplayerCursors.networkRecieveStartLerpToXY(cur, msg.x, msg.y)
    // }
}
exports.process = process;
function sendMessageToAll(msg) {
    var _default = {
        centerOn: false,
        equipSlot: diveObjectsData_1.EDiveEquipSlot.None,
        frame: 0,
        fromCrewId: 0,
        fromMultiId: 0,
        hint: EDiveInputHint.Null,
        targetId: 0,
        tx: 0,
        ty: 0,
    };
    var combinedMsg = Object.assign({}, _default, msg);
    websockets_sidecar_1.websockets._sendMessageToAll(write, combinedMsg, true);
}
exports.sendMessageToAll = sendMessageToAll;
